import {ExplanationTypeEnum} from '@doltech/utils/lib/constants';
import {types as t} from 'mobx-state-tree';

import {AbstractExplanation} from '../abstract-explanation.store';

const RawCharacter = t.model('RawCharacter', {
  id: t.maybeNull<any>(t.string),
  name: t.maybeNull<any>(t.string),
  avatarUrl: t.maybeNull<any>(t.string),
});

const Transcript = t.model('Transcript', {
  id: t.identifier,
  startTimeInSeconds: t.number,
  endTimeInSeconds: t.number,
  text: t.string,
  character: t.maybeNull(RawCharacter),
});

export const ListeningExplanationStore = AbstractExplanation.named(
  'LocatingDetailExplanation'
).props({
  type: ExplanationTypeEnum.LISTENING_EXPLANATION,
  startTimeInSeconds: t.maybeNull(t.number),
  endTimeInSeconds: t.maybeNull(t.number),
  transcripts: t.optional(t.array(Transcript), []),
});

